export class SelectOption {
  id: number;
  name: string;

  public constructor(id: number, email: string) {
    this.id = id;
    this.name = email;
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/_model/select-option.ts